import { QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from 'next-themes'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { CommandPalette } from './components/command/CommandPalette'
import { Toaster } from './components/ui/sonner'
import { AuthProvider } from './context/AuthContext'
import { ChiefLauncher } from '@/components/chief/ChiefPopup'
import { CeoProvider } from './context/CeoContext'
import { CommandRegistryProvider } from './context/CommandRegistryContext'
import { ConnectionProvider } from './context/ConnectionContext'
import { queryClient } from './lib/query'
import './styles.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem
      storageKey="xo-admin-theme"
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <ConnectionProvider>
              <CommandRegistryProvider>
                <CeoProvider>
                  <App />
                  <CommandPalette />
                  <ChiefLauncher />
                  <Toaster richColors position="top-right" closeButton />
                </CeoProvider>
              </CommandRegistryProvider>
            </ConnectionProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
)
